import { FormGroup } from '@angular/forms';

export interface InvalidClientField {
  controlName: string;
  labelKey: string;
}

export const CLIENT_FIELD_LABEL_KEYS: Record<string, string> = {
  firstName: 'NAME',
  lastName: 'LAST_NAME',
  email: 'EMAIL',
  phone: 'PHONE',
  documentType: 'DOCUMENT_TYPE',
  nationalId: 'ID_NUMBER',
  loginMethod: 'LOGIN_METHOD',
  password: 'PASSWORD',
  bornDate: 'BIRTH_DATE',
};

export function markFormGroupTouched(form: FormGroup): void {
  form.markAllAsTouched();
  form.updateValueAndValidity();
}

export function getInvalidClientFields(form: FormGroup): InvalidClientField[] {
  return Object.keys(CLIENT_FIELD_LABEL_KEYS)
    .filter((controlName) => form.get(controlName)?.invalid)
    .map((controlName) => ({
      controlName,
      labelKey: CLIENT_FIELD_LABEL_KEYS[controlName],
    }));
}
